export const getters = {
    company: (state) => state.company
}